var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 38,
    viewBox: "0 0 285 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_45456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.733 20.7226H107.957V27.8666H103.967V10.1333H107.957V17.3026H110.832L115.392 10.1333H119.629L113.954 18.696L119.803 27.8666H115.243L110.733 20.7226Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.438 28.0693C126.033 28.0693 124.769 27.7738 123.646 27.1827C122.539 26.5747 121.672 25.7387 121.044 24.6747C120.416 23.6107 120.102 22.4032 120.102 21.052C120.102 19.7008 120.416 18.4933 121.044 17.4293C121.672 16.3653 122.539 15.5378 123.646 14.9467C124.769 14.3387 126.033 14.0347 127.438 14.0347C128.842 14.0347 130.098 14.3387 131.205 14.9467C132.312 15.5378 133.179 16.3653 133.808 17.4293C134.435 18.4933 134.749 19.7008 134.749 21.052C134.749 22.4032 134.435 23.6107 133.808 24.6747C133.179 25.7387 132.312 26.5747 131.205 27.1827C130.098 27.7738 128.842 28.0693 127.438 28.0693ZM127.438 24.8267C128.43 24.8267 129.239 24.4888 129.867 23.8133C130.511 23.1208 130.834 22.2005 130.834 21.052C130.834 19.9035 130.511 18.9915 129.867 18.316C129.239 17.6235 128.43 17.2773 127.438 17.2773C126.447 17.2773 125.629 17.6235 124.985 18.316C124.341 18.9915 124.018 19.9035 124.018 21.052C124.018 22.2005 124.341 23.1208 124.985 23.8133C125.629 24.4888 126.447 24.8267 127.438 24.8267Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.419 27.8666V19.7093L146.429 26.5493H144.794L140.903 19.684V27.8666H137.408V14.2373H141.448L145.711 22.116L150.246 14.2373H153.864L153.914 27.8666H150.419Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.875 14.2373V27.8666H167.009V17.48H161.457V27.8666H157.616V14.2373H170.875Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.544 21.1027C187.544 21.1533 187.519 21.508 187.469 22.1667H177.383C177.564 23.0112 177.994 23.6782 178.671 24.168C179.348 24.6578 180.191 24.9027 181.199 24.9027C181.893 24.9027 182.504 24.8013 183.033 24.5987C183.578 24.3792 184.082 24.0413 184.545 23.5853L186.602 25.8653C185.345 27.3347 183.512 28.0693 181.1 28.0693C179.596 28.0693 178.266 27.7738 177.11 27.1827C175.953 26.5747 175.061 25.7387 174.434 24.6747C173.805 23.6107 173.492 22.4032 173.492 21.052C173.492 19.7178 173.797 18.5187 174.409 17.4547C175.036 16.3738 175.887 15.5378 176.961 14.9467C178.052 14.3387 179.266 14.0347 180.605 14.0347C181.909 14.0347 183.09 14.3218 184.148 14.896C185.205 15.4702 186.032 16.2978 186.627 17.3787C187.238 18.4427 187.544 19.684 187.544 21.1027ZM180.629 17.024C179.753 17.024 179.018 17.2773 178.424 17.784C177.829 18.2907 177.465 18.9832 177.333 19.8613H183.901C183.768 19 183.405 18.316 182.81 17.8093C182.215 17.2858 181.488 17.024 180.629 17.024Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.248 17.48H196.738V27.8666H192.897V17.48H188.386V14.2373H201.248V17.48Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.714 21.1027C215.714 21.1533 215.689 21.508 215.64 22.1667H205.553C205.735 23.0112 206.164 23.6782 206.842 24.168C207.52 24.6578 208.362 24.9027 209.37 24.9027C210.064 24.9027 210.675 24.8013 211.204 24.5987C211.749 24.3792 212.253 24.0413 212.715 23.5853L214.772 25.8653C213.517 27.3347 211.683 28.0693 209.271 28.0693C207.767 28.0693 206.437 27.7738 205.281 27.1827C204.124 26.5747 203.232 25.7387 202.604 24.6747C201.976 23.6107 201.662 22.4032 201.662 21.052C201.662 19.7178 201.968 18.5187 202.579 17.4547C203.207 16.3738 204.058 15.5378 205.132 14.9467C206.222 14.3387 207.437 14.0347 208.775 14.0347C210.08 14.0347 211.262 14.3218 212.319 14.896C213.376 15.4702 214.202 16.2978 214.797 17.3787C215.408 18.4427 215.714 19.684 215.714 21.1027ZM208.8 17.024C207.924 17.024 207.189 17.2773 206.594 17.784C205.999 18.2907 205.636 18.9832 205.504 19.8613H212.071C211.938 19 211.575 18.316 210.981 17.8093C210.386 17.2858 209.658 17.024 208.8 17.024Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.678 14.2373H222.519V19.5573H228.318V14.2373H232.185V27.8666H228.318V22.7746H222.519V27.8666H218.678V14.2373Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.903 24.624V30.856H247.309V27.8666H235.885V14.2373H239.726V24.624H245.104V14.2373H248.97V24.624H250.903Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.334 14.2373H257.175V22.344L263.668 14.2373H267.212V27.8666H263.371V19.76L256.903 27.8666H253.334V14.2373Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93 14.2373H274.771V22.344L281.264 14.2373H284.808V27.8666H280.967V19.76L274.498 27.8666H270.93V14.2373Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2935 10.1333V27.8666H62.3035V13.4773H54.4722V27.8666H50.4822V10.1333H66.2935Z",
    fill: "url(#paint2_linear_400_45456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1526 14.0347C79.3917 14.0347 80.5151 14.3302 81.523 14.9213C82.5473 15.4955 83.3486 16.3147 83.9269 17.3787C84.5051 18.4258 84.7943 19.6502 84.7943 21.052C84.7943 22.4538 84.5051 23.6867 83.9269 24.7507C83.3486 25.7978 82.5473 26.6168 81.523 27.208C80.5151 27.7822 79.3917 28.0693 78.1526 28.0693C76.4507 28.0693 75.1125 27.5205 74.1378 26.4227V32.7813H70.2717V14.2373H73.9643V15.808C74.9225 14.6258 76.3187 14.0347 78.1526 14.0347ZM77.4834 24.8267C78.4747 24.8267 79.2843 24.4888 79.9121 23.8133C80.5565 23.1208 80.8787 22.2005 80.8787 21.052C80.8787 19.9035 80.5565 18.9915 79.9121 18.316C79.2843 17.6235 78.4747 17.2773 77.4834 17.2773C76.4921 17.2773 75.6743 17.6235 75.03 18.316C74.4021 18.9915 74.0882 19.9035 74.0882 21.052C74.0882 22.2005 74.4021 23.1208 75.03 23.8133C75.6743 24.4888 76.4921 24.8267 77.4834 24.8267Z",
    fill: "url(#paint3_linear_400_45456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7491 28.0693C92.3447 28.0693 91.0808 27.7738 89.9574 27.1827C88.8504 26.5747 87.983 25.7387 87.3552 24.6747C86.7274 23.6107 86.4135 22.4032 86.4135 21.052C86.4135 19.7008 86.7274 18.4933 87.3552 17.4293C87.983 16.3653 88.8504 15.5378 89.9574 14.9467C91.0808 14.3387 92.3447 14.0347 93.7491 14.0347C95.1534 14.0347 96.4091 14.3387 97.5161 14.9467C98.623 15.5378 99.4904 16.3653 100.118 17.4293C100.746 18.4933 101.06 19.7008 101.06 21.052C101.06 22.4032 100.746 23.6107 100.118 24.6747C99.4904 25.7387 98.623 26.5747 97.5161 27.1827C96.4091 27.7738 95.1534 28.0693 93.7491 28.0693ZM93.7491 24.8267C94.7404 24.8267 95.55 24.4888 96.1778 23.8133C96.8222 23.1208 97.1444 22.2005 97.1444 21.052C97.1444 19.9035 96.8222 18.9915 96.1778 18.316C95.55 17.6235 94.7404 17.2773 93.7491 17.2773C92.7578 17.2773 91.94 17.6235 91.2957 18.316C90.6513 18.9915 90.3291 19.9035 90.3291 21.052C90.3291 22.2005 90.6513 23.1208 91.2957 23.8133C91.94 24.4888 92.7578 24.8267 93.7491 24.8267Z",
    fill: "url(#paint4_linear_400_45456)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_45456",
    x1: 19.0137,
    y1: -1.34117,
    x2: 36.0305,
    y2: 62.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#15395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112A45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_400_45456",
    x1: -5.49311,
    y1: -9.38823,
    x2: 17.0421,
    y2: 51.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B7F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_45456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logoText.c9613b983562a491e05dfb309205dfcf.svg";
export { ForwardRef as ReactComponent };